




















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List, Dialog, Toast, Popup, Checkbox, Button } from 'vant';
import moment from 'moment';
import openAppTip from '@/plugins/WxOpenAppTip';
import {
  fetchAds,
  studentUploadCheck,
  getUserList,
  fetchUserState,
} from '../api';
Vue.use(List)
  .use(Dialog)
  .use(Toast)
  .use(openAppTip)
  .use(Popup)
  .use(Checkbox)
  .use(Button);

// 根据环境跳转地址
const ENV_NAME_URL: { [key: string]: any } = {
  development: () => ` http://172.16.18.130:8081/composition/contribute`,
  TEST: () => `https://testwap.cqcb.com/shangyou_news/composition/contribute`,
  production: () => `https://wap.cqcb.com/shangyou_news/composition/contribute`,
};
// 上传开始、结束时间
const BEGIN_TIME = '2023/06/01 10:00';
const END_TIME = '2024/01/30 24:00';

@Component
export default class User extends Vue {
  checked = false;

  show = false;
  ads = [];
  list: any[] = [];
  finished = false;
  page = 1;
  loading = false;
  isApp = false;
  loginState = true;
  userType = 0;
  userList: any = [];
  studentUploadCheckState = false;
  userStateCode = 0;
  grade = [
    {
      text: '一年级',
      value: 1,
    },
    {
      text: '二年级',
      value: 2,
    },
    {
      text: '三年级',
      value: 3,
    },
    {
      text: '四年级',
      value: 4,
    },
    {
      text: '五年级',
      value: 5,
    },
    {
      text: '六年级',
      value: 6,
    },
    {
      text: '初一',
      value: 7,
    },
    {
      text: '初二',
      value: 8,
    },
    {
      text: '初三',
      value: 9,
    },
    {
      text: '高一',
      value: 10,
    },
    {
      text: '高二',
      value: 11,
    },
    {
      text: '高三',
      value: 12,
    },
    {
      text: '专科',
      value: 16,
    },
    {
      text: '本科',
      value: 17,
    },
    {
      text: '硕士研究生',
      value: 18,
    },
    {
      text: '博士研究生',
      value: 19,
    },
  ];
  async created() {
    this.isApp = !!window.udid;
    this.getAds();
    this.onLoad();
    await this.fetchUserType();
    await this.uploadCheck();
  }
  gradeText(val: string) {
    return this.grade.find((item) => item.value === +val);
  }
  onNavToUpload() {
    if (!this.checkInUploadTime()) {
      return;
    }
    if (!this._beforeJumpToUploadCheck()) {
      return false;
    }
    // 学生已经传过提示
    if (this.studentUploadCheckState) {
      Toast('你已上传过作品');
      return;
    }
    // 没有账户信息提示
    if (+this.userStateCode === 201) {
      Toast('请先进入我要参赛完成注册。');
      return;
    }
    // 账户在审核中提示
    if (+this.userStateCode === 202) {
      Toast('你的作文用户正在审核中');
      return;
    }
    this.show = true;
  }
  confrimUpload() {
    if (!this.checked) {
      Toast('请先阅读以上规则并勾选已阅读');
      return;
    }
    const userLogin = window.gettoken() && window.gettoken() !== 'null';

    if (this.isApp && userLogin) {
      location.href =
        ENV_NAME_URL[process.env.VUE_APP_ENV_NAME as string]() +
        `?isContinuous=false&sourceSite=${location.href}&from=activity`;
    } else {
      this.$openAppTip();
    }
  }
  async uploadCheck() {
    if (+this.userType === 2) {
      return;
    }
    const ret: any = await studentUploadCheck();
    if (ret.code === 203) {
      this.loginState = false;
    }
    if (ret.code === 100) {
      this.studentUploadCheckState = true;
    }
  }
  // 检查是否在活动上传日期内
  checkInUploadTime() {
    const now = moment();
    const begin = moment(BEGIN_TIME);
    const end = moment(END_TIME);
    if (now < begin) {
      Toast('活动投稿暂未开通，请于2022.06.01 10:00参与投稿!');
      return false;
    } else if (end < now) {
      Toast('活动投稿时间已截至！');
      return false;
    }
    return true;
  }
  async getAds() {
    const ret = await fetchAds(2);
    this.ads = ret.data;
  }
  async onLoad() {
    this.loading = true;
    const ret: any = await getUserList(this.page);
    this.loading = false;
    try {
      if (ret.code === 200 && ret.data.length > 0) {
        this.userList = [...this.userList, ...ret.data];
        this.userList.map((item: any) => {
          item.createtime = moment(item.createtime * 1000).format(
            'YYYY-MM-DD HH:mm:ss',
          );
        });
        this.page++;
      } else {
        this.finished = true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  toDetail(item: any) {
    this.$router.push(`detail?id=${item.id}`);
  }
  jumpToAdPage(url: string) {
    location.href = url;
  }
  _beforeJumpToUploadCheck() {
    // 没在app提示下载打开
    if (!this.isApp) {
      this.$openAppTip();
      return false;
    }
    // 在app没登录的时候提示登录
    const userLogin = window.gettoken() && window.gettoken() !== 'null';
    if (window.udid && !userLogin) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
      return false;
    }
    return true;
  }
  formatDate(time: string) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }
  async fetchUserType() {
    const ret: any = await fetchUserState();
    if (+ret.statusCode === 203) {
      this.userType = ret.data.userInfo.type;
    }
    this.userStateCode = ret.statusCode;
  }
  // 评审中  enable = 0 || enable = -1
  // 初赛入围 enable = 1 & enable_one = 1
  // 初赛淘汰 enable = 1 & enable_one = 0 & 时间点
  // 决赛入围 enable = 1 & enable_one = 1 & enable_two = 1
  // 决赛淘汰 enable = 1 & enable_one = 1 & enable_two = 0 & 时间点
  getCompositionState(item: any) {
    const { enable, enable_one, enable_two } = item;
    const STEP_ONE_END_TIME = new Date('2024/02/16 24:00').getTime();
    const STEP_TWO_END_TIME = new Date('2024/02/28 24:00').getTime();
    const NOW = new Date().getTime();
    const doing = NOW < STEP_ONE_END_TIME;
    if (doing) {
      return '评审中';
    } else if (+enable === -1) {
      return '作品未入围，继续努力，明年创造佳绩';
    } else if (
      +enable === 1 &&
      +enable_one === 1 &&
      +enable_two === 0 &&
      NOW > STEP_TWO_END_TIME
    ) {
      return '作品未入围，继续努力，明年创造佳绩';
    } else if (
      +enable === 1 &&
      +enable_one === 1 &&
      +enable_two === 1 &&
      NOW > STEP_TWO_END_TIME
    ) {
      return '决赛入围';
    } else if (+enable === 1 && +enable_one === 0 && NOW > STEP_ONE_END_TIME) {
      return '作品未入围，继续努力，明年创造佳绩';
    } else if (+enable === 1 && +enable_one === 1 && NOW < STEP_TWO_END_TIME) {
      return '初赛入围';
    }
  }
}
